import React, { Fragment } from 'react';
import { Row, Col, Table} from 'reactstrap';
import convertToRupees from '../../../../../utilities/convertToRupees';


const ProductDetails = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" className='pad-l-r-40 pad-b-0'>
                    <Table>
                        <tbody>
                            <tr>
                                <th>Product Name</th>
                                <td>{data?.product?.product_name}</td>
                            </tr>
                            <tr>
                                <th>Cost Price</th>
                                <td>{convertToRupees(data?.product?.cost_price, true)}</td>
                            </tr>
                            <tr>
                                <th>Travel Partner Commission</th>
                                <td>{data?.product?.dealer_commission_type === "UPFRONT" ? "Upfront DC" : "Direct DC"}</td>
                            </tr>
                            <tr>
                                <th>Price to Travel Partner (Include tax) </th>
                                <td>{convertToRupees(data?.product?.selling_price, true)|| "-"}</td>
                            </tr>

                            {data?.policy?.upfront_dc > 0 && (

                                <tr>
                                    <th>Price to Customer</th>
                                    <td>{convertToRupees(data?.policy?.net_payable_amount + data?.policy?.upfront_dc + data?.policy?.upfront_dc_tax, true)}</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default ProductDetails;